var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStripeLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 24,
    fill: "none",
    viewBox: "0 0 58 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#32325D",
    fillRule: "evenodd",
    d: "M58 12.4c0-4.1-1.998-7.337-5.816-7.337-3.835 0-6.155 3.236-6.155 7.305 0 4.823 2.74 7.258 6.67 7.258 1.918 0 3.367-.432 4.463-1.041V15.38c-1.096.545-2.352.882-3.947.882-1.563 0-2.949-.545-3.126-2.436h7.879c0-.208.032-1.041.032-1.426zM50.04 10.88c0-1.81 1.112-2.564 2.127-2.564.982 0 2.03.753 2.03 2.564H50.04zM39.812 5.063c-1.579 0-2.594.737-3.158 1.25l-.21-.994H32.9V24l4.028-.85.016-4.533c.58.416 1.434 1.01 2.852 1.01 2.884 0 5.51-2.308 5.51-7.387-.016-4.646-2.674-7.177-5.494-7.177zm-.967 11.039c-.95 0-1.514-.337-1.9-.754l-.017-5.943c.42-.465 1-.786 1.917-.786 1.467 0 2.482 1.635 2.482 3.733 0 2.147-1 3.75-2.482 3.75zM27.357 4.117l4.044-.865V0l-4.044.85v3.267z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#32325D",
    d: "M31.401 5.335h-4.044v14.019h4.044V5.335z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#32325D",
    fillRule: "evenodd",
    d: "M23.021 6.52l-.258-1.185h-3.48v14.019h4.028v-9.5c.95-1.235 2.562-1.01 3.061-.834V5.335c-.515-.192-2.4-.545-3.351 1.186zM14.967 1.858l-3.931.834-.016 12.833c0 2.37 1.788 4.117 4.172 4.117 1.321 0 2.288-.24 2.82-.529v-3.252c-.516.208-3.061.945-3.061-1.426V8.748h3.06V5.335h-3.06l.016-3.477zM4.076 9.405c0-.625.516-.866 1.37-.866 1.224 0 2.77.369 3.995 1.026V5.8c-1.337-.529-2.658-.737-3.995-.737C2.175 5.063 0 6.76 0 9.597c0 4.422 6.122 3.717 6.122 5.623 0 .737-.644.978-1.546.978-1.338 0-3.045-.545-4.399-1.282v3.813c1.499.64 3.013.913 4.399.913 3.35 0 5.655-1.65 5.655-4.518-.017-4.774-6.155-3.925-6.155-5.72z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStripeLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stripe_logo.d1da003a.svg";
export { ForwardRef as ReactComponent };